import {AfterContentInit, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {DcpHeadlineData} from '@app/model/dcp-headline-data';
import {DcpMedia, IMAGE_FORMAT} from '@app/model/dcp-media';
import {JsonService, TypeValuePair} from '@dcp/configurator';
import {Product} from '@spartacus/core';
import {CurrentProductService} from '@spartacus/storefront';
import {Observable} from 'rxjs';
import {DcpProductUtilitiesService} from '../../services/dcp-product-utilities.service';
import {NavigationLink} from '../navigation-bar/navigation-link';
import {ProductDetailsNavigationLinkService} from '../navigation-bar/product-details-navigation-link.service';
import {ProductDetailsSectionComponent} from '../product-details-section/product-details-section.component';

interface CustomDcpHeadlineData extends DcpHeadlineData {
  media: CustomDcpMedia[];
}

interface CustomDcpMedia extends DcpMedia {
  right?: boolean;
}

@Component({
  selector: 'dcp-features-and-benefits',
  templateUrl: './features-and-benefits.component.html',
  styleUrls: ['./features-and-benefits.component.scss']
})
export class FeaturesAndBenefitsComponent extends ProductDetailsSectionComponent
  implements OnInit, OnDestroy, AfterContentInit {

  product$: Observable<Product>;
  product: Product;
  benefits: CustomDcpHeadlineData[] = [];
  benefitsExtended = false;
  features: CustomDcpHeadlineData[] = [];
  featuresExtended = false;
  benefitSlotLimit = 3;
  featureSlotLimit = 4;
  navLink: NavigationLink = {
    headline: 'productDetails.features',
    id: 'benefits-and-features'
  };

  constructor(
    dcpProductUtilitiesService: DcpProductUtilitiesService,
    protected currentProductService: CurrentProductService,
    protected changeDetection: ChangeDetectorRef,
    protected productDetailsNavigationLinkService: ProductDetailsNavigationLinkService,
    private jsonService: JsonService,
  ) {
    super(currentProductService, changeDetection, productDetailsNavigationLinkService, dcpProductUtilitiesService);
  }

  get hasBenefits(): boolean {
    return !!this.benefits && this.benefits.length > 0;
  }

  get hasFeatures(): boolean {
    return !!this.features && this.features.length > 0;
  }

  get limitedBenefits(): CustomDcpHeadlineData[] {
    return this.benefitsExtended ? this.benefits : this.benefits.slice(0, this.benefitSlotLimit);
  }

  get limitedFeatures(): CustomDcpHeadlineData[] {
    return this.featuresExtended ? this.features : this.features.slice(0, this.featureSlotLimit);
  }

  get featuresExceedsLimit(): boolean {
    return this.features.length > this.featureSlotLimit;
  }

  get benefitsExceedsLimit(): boolean {
    return this.benefits.length > this.benefitSlotLimit;
  }

  isVisible(): boolean {
    return this.hasBenefits || this.hasFeatures;
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  ngAfterContentInit(): void {
    super.ngAfterContentInit();
  }

  toggleBenefits() {
    this.benefitsExtended = !this.benefitsExtended;
  }

  toggleBenefitsWithKeyboard(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.toggleBenefits();
    }
  }

  toggleFeatures() {
    this.featuresExtended = !this.featuresExtended;
  }

  toggleFeaturesWithKeyboard(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.toggleFeatures();
    }
  }

  prepareData(): void {
    this.prepareHeadlines();
  }

  isImageFormat(format: string): boolean {
    return format === IMAGE_FORMAT;
  }

  prepareHeadlines(): void {
    this.benefits = [];
    this.features = [];
    if (this.product?.data) {
      const rawHeadlines: TypeValuePair = this.product.data.find(entry => entry.type === 'headlines');
      try {
        if (!!rawHeadlines && rawHeadlines.value) {
          const parsedHeadlines: CustomDcpHeadlineData[] = this.jsonService.parseSafely(rawHeadlines.value) as CustomDcpHeadlineData[];
          this.benefits = parsedHeadlines.filter(headline => headline.type === 'benefit');
          this.features = parsedHeadlines.filter(headline => headline.type === 'feature');
          this.alternateSide();
        }
      } catch (e) {
      }
    }
  }

  private alternateSide() {
    let alternateSide: boolean = true;
    for (const headline of this.features) {
      if (headline.media.length) {
        for (const media of headline.media) {
          media.right = alternateSide;
        }
        alternateSide = !alternateSide;
      }
    }
  }
}
